import { NavigationState } from './types';

export const initialState = (): NavigationState => ({
  receivedAppsCount: 0,
  unreadMessageCount: 0,
  unreadBookingRequestsCount: 0,
});

const state = initialState;
export default state;
